import type { ProductAttribute, ProductAttributeGroup, ProductAttributeGroupOfValue } from "../Product.js";

export function getProductAttributeGroupsOfValues(
	groups: ProductAttributeGroup[],
	values: Record<ProductAttributeGroup["id"], ProductAttribute["id"]>,
): ProductAttributeGroupOfValue[] {
	return groups.map((group) => {
		const valueId = values[group.id];
		const value = group.values.find(({ id }) => valueId === id);
		if (!value) {
			throw new Error(`Could not find value: ${valueId} for attribute group: ${group.id}`);
		}
		return {
			...group,
			value,
		};
	});
}
